import { render, staticRenderFns } from "./PointOfSale.template.vue?vue&type=template&id=0a48c9ce&scoped=true&"
var script = {}
import style0 from "./PointOfSale.template.vue?vue&type=style&index=0&id=0a48c9ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48c9ce",
  null
  
)

export default component.exports